export type Column = {
	columnName: string;
	columnClass: string;
	columnTooltipHtml: string;
};

const getTableHeader = (columns: Column[]) => {
	const cells = columns.map((column, index) => ({
		key: `column-${index}`,
		content: column.columnName,
	}));
	return { cells };
};

export default getTableHeader;
